import { nanoid } from "@reduxjs/toolkit"
import useOnClickOutside from "common/hooks/useOnClickOutside"
import { isDate } from "lodash"
import moment from "moment"
import { Dropdown } from "primereact/dropdown"
import { InputNumber } from "primereact/inputnumber"
import { InputText } from "primereact/inputtext"
import { useCallback, useEffect, useMemo, useRef, useState } from "react"
import "./importGrid.scss"

const ImportGrid = ({
  data,
  setData,
  options,
  header = [],
  dropdownStates,
  setDropdownStates,
  editable = false,
  maxFiles = 5,
}: $TSMigrationFixMe) => {
  const headers = useMemo(
    () => Object.keys(data?.[0] || {}).map((header) => header),
    [data]
  )
  const [focusedCell, setFocusedCell] = useState(null)

  const tableRef = useRef()

  const clearFocusedCell = useCallback(() => setFocusedCell(null), [])
  // @ts-expect-error TS(2554): Expected 4 arguments, but got 2.
  useOnClickOutside(tableRef, clearFocusedCell)

  useEffect(() => {
    const newDropdownStates = {}

    if (Array.isArray(header)) {
      header.forEach((currentHeader) => {
        // @ts-expect-error TS(7053): Element implicitly has an 'any' type because expre...
        newDropdownStates[currentHeader.header] =
          currentHeader.initialDropdownValue || ""
      })
    }

    setDropdownStates(newDropdownStates)
  }, [header, setDropdownStates])

  const handleOnChangeCampos = (
    value: $TSMigrationFixMe,
    key: $TSMigrationFixMe
  ) => {
    setDropdownStates((prev: $TSMigrationFixMe) => {
      prev[key] = value
      return { ...prev }
    })
  }

  const handleSetFocusedCell = ({ idxRow, key }: $TSMigrationFixMe) => {
    // @ts-expect-error TS(2345): Argument of type '{ idxRow: $TSFixMe; key: $TSFixMe; }' is n...
    setFocusedCell({ idxRow, key })
  }

  const handleOnChangeInputText = (
    value: $TSMigrationFixMe,
    idxRow: $TSMigrationFixMe,
    key: $TSMigrationFixMe
  ) => {
    setData((prevData: $TSMigrationFixMe) => {
      prevData[idxRow][key] = value
      setData([...prevData])
    })
  }

  const handleLeaveInput = ({ key }: $TSMigrationFixMe) => {
    if (key === "Enter") setFocusedCell(null)
  }

  return (
    <div
      className='wrap-grid'
      // @ts-expect-error TS(2322): Type 'MutableRefObject<undefined>' is not assignab...
      ref={tableRef}
    >
      <table className='import-grid-table'>
        <thead>
          <tr>
            {headers?.map((header) => (
              <th key={nanoid()}>
                <div className='wrap-header'>
                  <span data-id={header}>{header}</span>
                  <Dropdown
                    style={{ marginTop: "5px" }}
                    options={options}
                    value={dropdownStates?.[header]}
                    onChange={(e) => handleOnChangeCampos(e.value, header)}
                    data-testid='dropdown'
                  />
                </div>
              </th>
            ))}
          </tr>
        </thead>

        <tbody>
          {data
            ?.filter(
              // @ts-expect-error TS(6133): 'entry' is declared but its value is never read.
              (entry: $TSMigrationFixMe, index: $TSMigrationFixMe) =>
                index < maxFiles
            )
            .map((articulo: $TSMigrationFixMe, idxRow: $TSMigrationFixMe) => (
              <tr key={nanoid()}>
                {Object.keys(articulo).map((key) => {
                  const isFocused =
                    // @ts-expect-error TS(2339): Property 'idxRow' does not exist on type 'never'.
                    focusedCell?.idxRow === idxRow && focusedCell?.key === key

                  return (
                    <td
                      key={nanoid()}
                      className={`${isFocused && editable ? "focused" : ""}`}
                      onClick={() => handleSetFocusedCell({ idxRow, key })}
                    >
                      {isFocused && editable ? (
                        typeof articulo[key] === "string" ? (
                          <InputText
                            autoFocus
                            className='input-cell'
                            onKeyPress={handleLeaveInput}
                            onChange={({ target }) =>
                              handleOnChangeInputText(target.value, idxRow, key)
                            }
                            value={articulo[key]}
                          />
                        ) : (
                          <InputNumber
                            autoFocus
                            className='input-cell'
                            // @ts-expect-error TS(2769): No overload matches this call.
                            onKeyPress={handleLeaveInput}
                            onChange={({ value }) =>
                              handleOnChangeInputText(value, idxRow, key)
                            }
                            value={articulo[key]}
                          />
                        )
                      ) : (
                        <span>
                          {isDate(articulo[key])
                            ? moment(articulo[key]).format("DD/MM/YYYY")
                            : articulo[key]}
                        </span>
                      )}
                    </td>
                  )
                })}
              </tr>
            ))}
        </tbody>
      </table>
    </div>
  )
}

export default ImportGrid
